import { ExportFileFormat } from 'app/layout/export-overlay';
import { BusinessPartnerListCommonExportProcessor } from './business-partner-list-common';
import { BUSINESS_PARTNER_TITLE, DETAILS_SECTION, LOCALIZED_PROPERTIES, LOCALIZED_PROPERTIES_PRICE_LIST, MAIN_SECTION } from './business-partner.constants';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';

export class BusinessPartnerListExcelExportProcessor extends BusinessPartnerListCommonExportProcessor {
    constructor() {
        super();
    }

    override onInit() {
        this.setSectionTitle(MAIN_SECTION, BUSINESS_PARTNER_TITLE);
        if (this.context.format === ExportFileFormat.CSV) {
        this.setSectionOptions(MAIN_SECTION, { ignoreTitleOnOutput: true });
        }
        this.localizeItemProperties(MAIN_SECTION, LOCALIZED_PROPERTIES);

        this.setSectionTitle(DETAILS_SECTION, 'Listas de Precios');
        this.localizeItemProperties(DETAILS_SECTION, LOCALIZED_PROPERTIES_PRICE_LIST);
    }

    override onAddData(item: BusinessPartnerAttributes) {
        this.addToSection(MAIN_SECTION, this.transformForMainSection(item));
        this.addToSection(DETAILS_SECTION, this.transformForPriceListSection(item));
    }
}